import { useEffect } from "react";
import { setToken } from "@/lib/api";
import { PageSpinner } from "@/components/ui/spinner";

/**
 * Landing route for the installed-PWA Google redirect flow. The server
 * redirects here with the JWT in the URL fragment (#token=...), which keeps
 * it out of server logs / Referer. We persist it and hard-navigate to "/"
 * so AuthProvider boots with the token present and hydrates the session.
 */
export default function GoogleReturnPage() {
    useEffect(() => {
        const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
        const token = new URLSearchParams(hash).get("token");
        if (token) {
            setToken(token);
            window.location.replace("/");
        } else {
            window.location.replace("/login?error=google_redirect");
        }
    }, []);

    return <PageSpinner />;
}
